import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthorized: false,
  username: '',
  hasBankData: false,
  isBlocked: false,
  clouderType: '',
  idUserStatus: null,
};

const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuthorized(state, action) {
      state.isAuthorized = action.payload;
    },
    setUsername(state, action) {
      state.username = action.payload;
    },
    setHasBankData(state, action) {
      state.hasBankData = action.payload;
    },
    setIsBlocked(state, action) {
      state.isBlocked = action.payload;
    },
    setClouderType(state, action) {
      state.clouderType = action.payload;
    },
    setIdUserStatus(state, action) {
      state.idUserStatus = action.payload;
    },
    logout: () => initialState,
  },
});

export const {
  logout,
  setIsAuthorized,
  setUsername,
  setHasBankData,
  setIsBlocked,
  setClouderType,
  setIdUserStatus,
} = loginSlice.actions;

export default loginSlice.reducer;
